import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-368">
      <div className="max-w-5xl mx-auto" data-id="element-369">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-370">
          Lo que <span className="text-[#FF6B00]" data-id="element-371">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-372">
          <div className="bg-black border border-[#FF6B00]/30 rounded-2xl p-6" data-id="element-373">
            <h3 className="text-[#FF6B00] text-xl font-black mb-4" data-id="element-374">
              🥁 LOS 6 TOMOS
            </h3>
            <div className="space-y-3" data-id="element-375">
              <div className="flex items-start gap-3 text-white" data-id="element-376">
                <span className="text-lg" data-id="element-377">🟢</span>
                <p className="text-sm" data-id="element-378">
                  <span className="font-bold" data-id="element-379">
                    Tomo 1 — Iniciación y Juego Rítmico
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-380">
                    · 3 a 7 años · 24 clases · Folklore como juego
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-381">
                <span className="text-lg" data-id="element-382">🟡</span>
                <p className="text-sm" data-id="element-383">
                  <span className="font-bold" data-id="element-384">
                    Tomo 2 — Fundamentos y Danzas Base
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-385">
                    · 8 a 13 años · 24 clases · Zapateo y 8 danzas completas
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-386">
                <span className="text-lg" data-id="element-387">🟠</span>
                <p className="text-sm" data-id="element-388">
                  <span className="font-bold" data-id="element-389">
                    Tomo 3 — Técnica Intermedia y Estilización
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-390">
                    · Jóvenes y adultos · 24 clases · Estilización y expresión
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-391">
                <span className="text-lg" data-id="element-392">🔴</span>
                <p className="text-sm" data-id="element-393">
                  <span className="font-bold" data-id="element-394">
                    Tomo 4 — Perfeccionamiento y Malambo
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-395">
                    · Nivel avanzado · 24 clases · Malambo completo
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-396">
                <span className="text-lg" data-id="element-397">🟣</span>
                <p className="text-sm" data-id="element-398">
                  <span className="font-bold" data-id="element-399">
                    Tomo 5 — Andragogía: Adultos y Tercera Edad
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-400">
                    · Adultos +55 · 24 clases · Danzas adaptadas y bienestar
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-401">
                <span className="text-lg" data-id="element-402">⭐</span>
                <p className="text-sm" data-id="element-403">
                  <span className="font-bold" data-id="element-404">
                    Tomo 6 — El Maestro Integral
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-405">
                    · Actos, muestras, gestión y negocio docente
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#FF6B00]/5 border border-[#FF6B00]/30 rounded-2xl p-8 text-center" data-id="element-406">
          <h3 className="text-[#FF6B00] text-xl font-black mb-6" data-id="element-407">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-408">
            <div className="flex items-start gap-2 text-left" data-id="element-409">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-410">✅</span>
              <span className="text-white text-sm" data-id="element-411">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-412">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-413">✅</span>
              <span className="text-white text-sm" data-id="element-414">
                24 clases con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-415">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-416">✅</span>
              <span className="text-white text-sm" data-id="element-417">
                Criterios de progresión por nivel y edad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-418">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-419">✅</span>
              <span className="text-white text-sm" data-id="element-420">
                Evaluaciones + rúbricas (escala 1-4)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-421">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-422">✅</span>
              <span className="text-white text-sm" data-id="element-423">
                Fichas de seguimiento por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-424">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-425">✅</span>
              <span className="text-white text-sm" data-id="element-426">
                Fichas coreográficas de cada danza
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-427">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-428">✅</span>
              <span className="text-white text-sm" data-id="element-429">
                Material original ProfePack®
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-430">
              <span className="text-[#FF6B00] font-bold flex-shrink-0" data-id="element-431">✅</span>
              <span className="text-white text-sm" data-id="element-432">
                100% adaptado al profe de folklore argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}